module.exports = __webpack_public_path__ + "static/media/Flaticon.d3d5bd87.ttf";